import { defineComponent as _defineComponent } from 'vue'
import { language } from '@tencent/ppd-base-libs';
import { computed, useSlots } from 'vue';
import TextFormatter from '@tencent/wphk-components-text-formatter/index.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'card-title',
  props: {
    title: null,
    isShowSplit: null,
    desc: null,
    isEnVertical: null
  },
  setup(__props: any) {

const props = __props as {
  title?: String,
  isShowSplit?: Boolean,
  desc?: String,
  isEnVertical?: Boolean, // 英文标题是否要上下布局（由于title或desc太长一行放不下）
}


const slots = useSlots();
console.log('====slots', slots);
const isEnVerticalMode = computed(() => props.isEnVertical && language.isEn());
const showSplit = computed(() => props.isShowSplit && !isEnVerticalMode.value);

return { __sfc: true,props, slots, isEnVerticalMode, showSplit, TextFormatter }
}

})